module.exports = __webpack_public_path__ + "img/4.8165c87e.png";